/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerCreateMutationRequest, ClientsControllerCreateMutationResponse, ClientsControllerCreate400, ClientsControllerCreate401, ClientsControllerCreate403 } from "../../models/clientsController/ClientsControllerCreate";

function getClientsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/clients` as const }  
  return res
}

/**
 * @summary Create a new client
 * {@link /api/v1/clients}
 */
export async function clientsControllerCreate(data?: ClientsControllerCreateMutationRequest, config: Partial<RequestConfig<ClientsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ClientsControllerCreateMutationResponse, ResponseErrorConfig<ClientsControllerCreate400 | ClientsControllerCreate401 | ClientsControllerCreate403>, ClientsControllerCreateMutationRequest>({ method : "POST", url : getClientsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}